import { render, staticRenderFns } from "./InfoChange.vue?vue&type=template&id=09f78e6c&"
import script from "./InfoChange.vue?vue&type=script&lang=js&"
export * from "./InfoChange.vue?vue&type=script&lang=js&"
import style0 from "./InfoChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports